//export const API_URI = "https://2tdqjv9d7i.execute-api.eu-north-1.amazonaws.com/default"
export const API_URI = process.env.REACT_APP_API_ENDPOINT

export enum SCHOOL {
  BORGAR = "borgar",
  PAULI = "pauli",
  MIG = "mig",
}